import gsap from 'gsap';

const tl = gsap.timeline();
let atCenter = true;
let at3DShelf = false;
let atDesk = false;
let at2D = false;
let atAbout = false;
let atGames = false;
let atWindow = false;

let modelOut = false;
let aboutOut = false;
let inProgOut = false;
let gameOut = false;

export function animateCamera(
    intersections, 
    camera, 
    buttons, 
    lod0Models, 
    lod1Models, 
    lod2Models, 
    imagePanels, 
    imageZoomPanels,
    aboutPanels,
    aboutButtons,
    games,
    inProgPanels,
    infoCards,
    linkButtons,
    cameraOS

) {

    let firstObject;
    if(intersections.length > 0) {
        if (intersections[0].object.visible){
            firstObject = intersections[0].object;
        }
        else {
            firstObject = intersections[1].object;
        }
        let objectName = firstObject.userData.name;
        let objectPosition = intersections[0].point;

        if(objectName?.includes("Interact")){
            
            switch (objectName) {
                case "Interact GameShelf":
                    console.log(objectName);
                    console.log(objectPosition);
                    cameraOS.cameraMoving = true;
                    atCenter = false;
                    atGames = true;
                    updateCameraPosition(-1, 2, -4);
                    updateCameraRotation(0, -0.5, 0);
                    showButtons(3);
                    break;
                case "Interact Desk":
                    console.log(objectName);
                    console.log(objectPosition);
                    cameraOS.cameraMoving = true;
                    atCenter = false;
                    updateCameraPosition(3, 4, -1);
                    updateCameraRotation(0, -1.5, 0);
                    if (!atDesk){
                        for (let i = 0; i < inProgPanels.length; i++) {
                            if (inProgPanels[i].visible == true) {
                                inProgPanels[i].visible = false;
                                inProgPanels[i].position.x = 1;
    
                            }
                            else {
                                inProgPanels[i].visible = true;
                            }
                        }
                    }
                    showButtons(4);
                    atDesk = true;
                    break;
                case "Interact 3DShelf":
                    console.log(objectName);
                    console.log(objectPosition);
                    cameraOS.cameraMoving = true;
                    atCenter = false
                    updateCameraPosition(-4.5, 1.65, 0.5);
                    updateCameraRotation(0, 0.852, 0);
                    if(!at3DShelf){
                        for (let i = 0; i < lod2Models.length; i++) {
                            lod2Models[i].visible = false;
                            lod1Models[i].visible = true;
                            lod0Models[i].visible = false;
                        }
                    }
                    at3DShelf = true;
                    modelOut = false;
                    showButtons(0);
                    //showButtons(5);
                    break;
                case "Interact 2DFrame":
                    console.log(objectName);
                    console.log(objectPosition);
                    cameraOS.cameraMoving = true;
                    atCenter = false;
                    updateCameraPosition(-7, 5.58, -0.7);
                    updateCameraRotation(0, 0.87, 0);
                    if(!at2D){
                        for (let i = 0; i < imagePanels.length; i++){
                            imagePanels[i].visible = true;
                            imagePanels[i].position.x = 0;
                        }
                        infoCards[6].visible = true;
                        linkButtons[6].position.x = -9.6;
                        linkButtons[7].position.x = -9.3;
                        linkButtons[8].position.x = -9;
                        showButtons(1);
                    }
                    at2D = true;
                    break;
                case "Interact CorkBoard":
                    console.log(objectName);
                    console.log(objectPosition);
                    cameraOS.cameraMoving = true;
                    atCenter = false;
                    updateCameraPosition(-2, 6.5, -5);
                    updateCameraRotation(0, 0.88, 0);
                    if(!atAbout){
                        gsap.to(aboutPanels, {
                            onUpdate: function() {
                                for (let i = 0; i < 5; i++){
                                    aboutPanels[i].visible = true;
                                    aboutPanels[i].position.x = 0;
                                }
                                aboutPanels[14].visible = true;
                                aboutPanels[14].position.x = 0;
    
                            }
                        })
                        gsap.to(aboutButtons, {
                            onUpdate: function() {
                                for (let i = 0; i < aboutButtons.length; i++) {
                                    aboutButtons[i].position.x = 0.05;
                                }
                            }
                        })
                        let g1 = getRandomInt(5, 7);
                        let g2 = getRandomInt(8, 10);
                        let g3 = getRandomInt(11, 13);
    
                        aboutPanels[g1].visible = true;
                        aboutPanels[g1].position.x = 0;
                        aboutPanels[g2].visible = true;
                        aboutPanels[g2].position.x = 0;
                        aboutPanels[g3].visible = true;
                        aboutPanels[g3].position.x = 0;
                        showButtons(2);
                    }
                    atAbout = true;
                    break;
                case "Interact Controller":
                    window.open('https://rinsdoll.github.io/UKSample/');
                    break;
                case "Interact Window":
                    cameraOS.cameraMoving = true;
                    atCenter = false;
                    atWindow = true;
                    updateCameraPosition(4.5, 5, -5);
                    updateCameraRotation(0, -0.70, 0);
                    showButtons(5);
                    break;
                default:
                    break;
            }
        }
        else if (objectName?.includes("Back")){
            if (!atCenter) {

                console.log("return to center");
                if (at3DShelf) {
                    at3DShelf = false;
                }
                else if (at2D) {
                    at2D = false;
                }
                else if (atAbout) {
                    atAbout = false;
                }
                else if (atGames) {
                    atGames = false;
                }
                else if (atDesk) {
                    atDesk = false;
                }
                else if (atWindow){
                    atWindow = false;
                }
                for (let i = 0; i < lod2Models.length; i++) {
                    lod2Models[i].visible = true;
                    lod1Models[i].visible = false;
                    lod0Models[i].visible = false;
                }
                lod0Models[0].position.set(-7.4, 2.2, -1.3);
                lod0Models[1].position.set(-6.7, 2.2, -2.4);
                lod0Models[2].position.set(-7.7, 1.155, -1.3);
                lod0Models[3].position.set(-6.7, 1.155, -2.4);
                lod0Models[4].position.set(-7.7, 0.25, -1.3);
                lod0Models[5].position.set(-6.7, 0.25, -2.4);
                modelOut = false;

                for (let i = 0; i < imagePanels.length; i++) {
                    imagePanels[i].visible = false;
                    imagePanels[i].position.x = -1;
                }
                for (let i = 1; i < imageZoomPanels.length; i++) {
                    imageZoomPanels[i].visible = false
                    imageZoomPanels[i].position.x = -1;
                }

                for (let i = 6; i < 27; i++) {
                    linkButtons[i].position.x = -10.6;
                    i++;
                    linkButtons[i].position.x = -10.3;
                    i++;
                    linkButtons[i].position.x = -10;
                }

                for (let i = 0; i < aboutPanels.length; i++) {
                    aboutPanels[i].visible = false;
                    aboutPanels[i].position.x = -1;
                    aboutPanels[i].position.y = 0;
                    aboutPanels[i].position.z = 0;
                }

                for (let i = 0; i < aboutButtons.length; i++) {
                    aboutButtons[i].position.x = -2;
                }
                for (let i = 0; i <= 5; i++) {
                    linkButtons[i].position.y = -2;
                }

                linkButtons[31].position.y = -1.6;

                games[0].position.set(-0.15, 2.08, -8.5);
                games[1].position.set(0.7, 2.08, -7.8,);
                games[2].position.set(1.5, 2.08, -7.2,);
                games[3].position.set(-0.15, 1.05, -8.5);
                games[4].position.set(1.5, 1.05, -7.2)

                for (let i = 27; i <= 30; i++) {
                    if (linkButtons[i].visible){
                        linkButtons[i].position.y = -1.4;
                    }
                };

                linkButtons[45].position.y = -5;

                inProgPanels[1].visible = false;
                inProgPanels[1].position.set(7.11, 3.81, -2.8);
                inProgPanels[3].visible = false;
                inProgPanels[3].position.set(7.11, 3.79, 0.67);
                inProgPanels[5].visible = false;
                inProgPanels[5].position.set(8.15, 3.5, -1.2);
                inProgPanels[0].visible = true;
                inProgPanels[2].visible = true;
                inProgPanels[4].visible = true;
                inProgPanels[0].position.x = 0;
                inProgPanels[2].position.x = 0;
                inProgPanels[4].position.x = 0;

                inProgOut = false;

                linkButtons[32].position.y = -4;
                
                for (let i = 0; i < infoCards.length; i++) {
                    infoCards[i].visible = false;
                }

                for (let i = 34; i <= 44; i++){
                    linkButtons[i].position.y = -1.2;
                    linkButtons[i].visible = false;
                }

                for(let i = 18; i <= 23; i++) {
                    infoCards[i].position.y = -2;
                    infoCards[i].visible = false;
                }

                for(let i = 0; i < games.length; i++) {
                    games[i].rotation.y = Math.PI/-4.5;
                }

                infoCards[0].position.y =-2;
                infoCards[1].position.y =-2;
                infoCards[2].position.y =-2;
                infoCards[3].position.y =-2;
                infoCards[4].position.y =-2;
                infoCards[5].position.y =-2;

                infoCards[13].position.y =-2;
                infoCards[14].position.y =-2;
                infoCards[15].position.y =-2;
                infoCards[16].position.y =-2;

                updateCameraPosition(0, 5, 6)
                tl.to(camera.rotation, {
                    x : 0,
                    y : 0,
                    z : 0,
                    duration: 0.5
                })
                .to(camera, {
                    onUpdate: function() {
                        cameraOS.cameraMoving = false;
                    }
                })
                aboutOut = false;
                atCenter = true;
                gameOut = false;

                gsap.to(buttons, {
                    onUpdate: function() {
                        for (let i = 0; i < buttons.children.length; i++){
                            if (buttons.children[i]){
                                buttons.children[i].visible = false;
                            }
                        }
                        
                    }
                })
            } 
           
        }
    }
    function updateCameraPosition(x, y, z) {

        gsap.to(camera.position, {
            x,
            y,
            z,
            duration: 1.5,
        })
    
    }

    function updateCameraRotation(x, y, z) {

        gsap.to (camera.rotation, {
            x,
            y,
            z,
            duration: 1.5
        })

    }

    function showButtons(i) {
        gsap.to(buttons, {
            onUpdate: function() {
                buttons.children[i].visible = true;
            }
        })
    }

    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

}

export function getAt3DShelf () {
    return at3DShelf;
}
export function getAt2DFrame () {
    return at2D;
}
export function getAtAboutBoard () {
    return atAbout;
}
export function getAtGameShelf () {
    return atGames;
}
export function getAtInProg () {
    return atDesk;
}

export function animateModel (intersections, lod0Models, lod1Models, infoCards, linkButtons) {

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName?.includes("Model") && at3DShelf){
            
            switch (true) {
                case objectName?.includes("Scissors") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[0].visible = false;
                        lod0Models[0].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[0].position, {
                            x: -5,
                            y: 1.25,
                            z: -0.5,
                            duration: 1.5,
                        })
                        .to(infoCards[0], {
                            onUpdate : function () {
                                infoCards[0].visible = true;
                                infoCards[0].position.y = 1.65;
                                linkButtons[0].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                    }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[0].position, {
                            x: -7.4,
                            y: 2.2,
                            z: -1.3,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[0].visible = false;
                                infoCards[0].position.y = -2;
                                linkButtons[0].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            }
                        })
                        .to(lod1Models[0], {
                            visible: true,
                            duration: 0
                        })
                        .to(lod0Models[0], {
                            visible: false,
                            duration: 0
                        })
                        
                    }
                    break;
                case objectName?.includes("Skelly") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[1].visible = false;
                        lod0Models[1].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[1].position, {
                            x: -5,
                            y: 1.25,
                            z: -0.5,
                            duration: 1.5,
                        })
                        .to(infoCards[1], {
                            onUpdate : function () {
                                infoCards[1].visible = true;
                                infoCards[1].position.y = 1.65;
                                linkButtons[1].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                    }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[1].position, {
                            x: -6.7,
                            y: 2.2,
                            z: -2.4,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[1].visible = false;
                                infoCards[1].position.y = -2;
                                linkButtons[1].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            } 
                        })
                        .to(lod1Models[1], {
                            visible: true,
                            duration: 0
                        })
                        .to(lod0Models[1], {
                            visible: false,
                            duration: 0
                        })
                        
                        
                    }
                    break;
                case objectName?.includes("Ember") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[2].visible = false;
                        lod0Models[2].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[2].position, {
                            x: -5.5,
                            y: 1.25,
                            z: -0.75,
                            duration: 1.5,
                        })
                        .to(infoCards[2], {
                            onUpdate : function () {
                                infoCards[2].visible = true;
                                infoCards[2].position.y = 1.65;
                                linkButtons[2].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                        }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[2].position, {
                            x: -7.7,
                            y: 1.155,
                            z: -1.3,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[2].visible = false;
                                infoCards[2].position.y = -2;
                                linkButtons[2].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            }
                        })
                        .to(lod1Models[2], {
                            visible: true,
                            duration: 0
                        })
                        .to(lod0Models[2], {
                            visible: false,
                            duration: 0
                        })
                        }
                        break;
                case objectName?.includes("Alien") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[3].visible = false;
                        lod0Models[3].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[3].position, {
                            x: -5,
                            y: 1.25,
                            z: -0.5,
                            duration: 1.5,
                        })
                        .to(infoCards[3], {
                            onUpdate : function () {
                                infoCards[3].visible = true;
                                infoCards[3].position.y = 1.65;
                                linkButtons[3].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                    }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[3].position, {
                            x: -6.7,
                            y: 1.155,
                            z: -2.4,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[3].visible = false;
                                infoCards[3].position.y = -2;
                                linkButtons[3].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            }
                        })
                        .to(lod1Models[3], {
                            visible: true,
                            duration: 0
                        })
                        .to(lod0Models[3], {
                            visible: false,
                            duration: 0
                        })
                        
                        
                    }
                    break;
                case objectName.includes("Beholder") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[4].visible = false;
                        lod0Models[4].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[4].position, {
                            x: -5,
                            y: 1.32,
                            z: -0.5,
                            duration: 1.5,
                        })
                        .to(infoCards[4], {
                            onUpdate : function () {
                                infoCards[4].visible = true;
                                infoCards[4].position.y = 1.65;
                                linkButtons[4].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                    }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[4].position, {
                            x: -7.7,
                            y: 0.25,
                            z: -1.3 ,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[4].visible = false;
                                infoCards[4].position.y = -2;
                                linkButtons[4].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            }
                        })
                        .to(lod1Models[4], {
                            visible: true,
                            duration: 0
                        })
                        .to(lod0Models[4], {
                            visible: false,
                            duration: 0
                        })
                        
                    }
                    break;
                case objectName?.includes("Charger") :
                    if (!modelOut){
                        console.log(modelOut);
                        lod1Models[5].visible = false;
                        lod0Models[5].visible = true;
                        modelOut = true;
                        tl.to(lod0Models[5].position, {
                            x: -5,
                            y: 1.25,
                            z: -0.5,
                            duration: 1.5,
                        })
                        .to(infoCards[5], {
                            onUpdate : function () {
                                infoCards[5].visible = true;
                                infoCards[5].position.y = 1.65;
                                linkButtons[5].position.y = 0.86;
                                linkButtons[31].position.y = 1.6;
                            }
                        })
                        break;
                    }
                    else {
                        console.log(modelOut);
                        tl.to(lod0Models[5].position, {
                            x: -6.7,
                            y: 0.25,
                            z: -2.4,
                            duration: 1.5,
                            onUpdate: function() {
                                modelOut = false;
                                infoCards[5].visible = false;
                                infoCards[5].position.y = -2;
                                linkButtons[5].position.y = -2;
                                linkButtons[31].position.y = -1.6;
                            }
                        })
                        .to(lod1Models[5], {
                            visible: true
                        })
                        .to(lod0Models[5], {
                            visible: false
                        })     
                    }
                    break;

            }
        }
        else if (objectName.includes("Link")) {
            switch (objectName) {
                case 'Scissors Link Artstation':
                    window.open('https://www.artstation.com/artwork/9ElWny');
                    break;
                case 'Skelly Link Artstation':
                    window.open('https://www.artstation.com/artwork/wr9V1w');
                    break;
                case 'Ember Link Artstation':
                    window.open('https://www.artstation.com/artwork/kQYEn6');
                    break;
                case 'Alien Link Artstation':
                    window.open('https://www.artstation.com/artwork/rlR9Zm');
                    break;
                case 'Beholder Link Artstation':
                    window.open('https://www.artstation.com/artwork/49V231');
                    break;
                case 'Charger Link Artstation':
                    window.open('https://www.artstation.com/artwork/P6nrzr');
                    break;
            }
        }
    };
}

export function animateImages(intersections, imagePanels, imageZoomPanels, infoCards, linkButtons) {
    if (intersections.length > 0){
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if (objectName?.includes('Image')) {
            switch (objectName) {
                case 'Image Dream Eater' :
                    imagePanels[1].visible = false;
                    imageZoomPanels[1].visible = true;
                    imageZoomPanels[1].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[7].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[9].position.x = -9.6;
                    linkButtons[10].position.x = -9.3;
                    linkButtons[11].position.x = -9;
                    break;
                case 'Image Dream Eater Zoom' :
                    imagePanels[1].visible = true;
                    imageZoomPanels[1].visible = false;
                    imageZoomPanels[1].position.x = -1;
                    infoCards[7].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[9].position.x = -10.6;
                    linkButtons[10].position.x = -10.3;
                    linkButtons[11].position.x = -10;
                    break;
                case 'Image Glory' :
                    imagePanels[2].visible = false;
                    imageZoomPanels[2].visible = true;
                    imageZoomPanels[2].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[8].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[12].position.x = -9.6;
                    linkButtons[13].position.x = -9.3;
                    linkButtons[14].position.x = -9;
                    break;
                case 'Image Glory Zoom' :
                    imagePanels[2].visible = true;
                    imageZoomPanels[2].visible = false;
                    imageZoomPanels[2].position.x = -1;
                    infoCards[8].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[12].position.x = -10.6;
                    linkButtons[13].position.x = -10.3;
                    linkButtons[14].position.x = -10;
                    break;
                case 'Image Skelly' :
                    imagePanels[3].visible = false;
                    imageZoomPanels[3].visible = true;
                    imageZoomPanels[3].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[9].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[15].position.x = -9.6;
                    linkButtons[16].position.x = -9.3;
                    linkButtons[17].position.x = -9;
                    break;
                case 'Image Skelly Zoom' :
                    imagePanels[3].visible = true;
                    imageZoomPanels[3].visible = false;
                    imageZoomPanels[3].position.x = -1;
                    infoCards[9].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[15].position.x = -10.6;
                    linkButtons[16].position.x = -10.3;
                    linkButtons[17].position.x = -10;
                    break;
                case 'Image Raven' :
                    imagePanels[4].visible = false;
                    imageZoomPanels[4].visible = true;
                    imageZoomPanels[4].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[10].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[18].position.x = -9.6;
                    linkButtons[19].position.x = -9.3;
                    linkButtons[20].position.x = -9;
                    break;
                case 'Image Raven Zoom' :
                    imagePanels[4].visible = true;
                    imageZoomPanels[4].visible = false;
                    imageZoomPanels[4].position.x = -1;
                    infoCards[10].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[18].position.x = -10.6;
                    linkButtons[19].position.x = -10.3;
                    linkButtons[20].position.x = -10;
                    break;
                case 'Image Wisteria' :
                    imagePanels[5].visible = false;
                    imageZoomPanels[5].visible = true;
                    imageZoomPanels[5].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[11].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[21].position.x = -9.6;
                    linkButtons[22].position.x = -9.3;
                    linkButtons[23].position.x = -9;
                    break;
                case 'Image Wisteria Zoom' :
                    imagePanels[5].visible = true;
                    imageZoomPanels[5].visible = false;
                    imageZoomPanels[5].position.x = -1;
                    infoCards[11].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[21].position.x = -10.6;
                    linkButtons[22].position.x = -10.3;
                    linkButtons[23].position.x = -10;
                    break;
                case 'Image Shunned House' :
                    imagePanels[6].visible = false;
                    imageZoomPanels[6].visible = true;
                    imageZoomPanels[6].position.x = 0;
                    for (let i = 6; i < infoCards.length; i++) {
                        if (infoCards[i].visible) {
                            infoCards[i].visible = false;
                        }
                    }
                    infoCards[12].visible = true;
                    linkButtons[6].position.x = -10.6;
                    linkButtons[7].position.x = -10.3;
                    linkButtons[8].position.x = -10;
                    linkButtons[24].position.x = -9.6;
                    linkButtons[25].position.x = -9.3;
                    linkButtons[26].position.x = -9;
                    break;
                case 'Image Shunned House Zoom' :
                    imagePanels[6].visible = true;
                    imageZoomPanels[6].visible = false;
                    imageZoomPanels[6].position.x = -1;
                    infoCards[12].visible = false;
                    infoCards[6].visible = true;
                    linkButtons[6].position.x = -9.6;
                    linkButtons[7].position.x = -9.3;
                    linkButtons[8].position.x = -9;
                    linkButtons[24].position.x = -10.6;
                    linkButtons[25].position.x = -10.3;
                    linkButtons[26].position.x = -10;
                    break;
            }
        }
        else if (objectName.includes('Link')) {
            switch (objectName) {
                case 'Intro Link Instagram':
                    window.open('https://www.instagram.com/rinsdoll/');
                    break;
                case 'Intro Link Youtube':
                    window.open('https://www.youtube.com/@rinsdoll');
                    break;
                case 'Intro Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll');
                    break;
                case 'DreamEater Link Instagram':
                    window.open('https://www.instagram.com/p/DCN0OlgsRie/?img_index=1');//TODO:Update
                    break;
                case 'DreamEater Link Youtube':
                    window.open('https://youtube.com/shorts/ps78_la1P_M?feature=share');
                    break;
                case 'DreamEater Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Dream-Eater-1120772092');//TODO:Update
                    break;
                case 'Glory Link Instagram':
                    window.open('https://www.instagram.com/p/DCPISEDvTJ9/');//TODO:Update
                    break;
                case 'Glory Link Youtube':
                    window.open('https://youtu.be/9vxyPF0YgwI');
                    break;
                case 'Glory Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Glory-Cover-Art-1120959244');//TODO:Update
                    break;
                case 'Skelly Link Instagram':
                    window.open('https://www.instagram.com/p/DCNyaJNMeDN/?img_index=1');//TODO:Update
                    break;
                case 'Skelly Link Youtube':
                    window.open('https://youtube.com/shorts/-puesWyv9tg');
                    break;
                case 'Skelly Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Ink-Slinger-1120768402');//TODO:Update
                    break;
                case 'Raven Link Instagram':
                    window.open('https://www.instagram.com/p/DCNGeLiPsAM/');//TODO:Update
                    break;
                case 'Raven Link Youtube':
                    window.open('https://youtube.com/shorts/6_xHFkB2_FU');
                    break;
                case 'Raven Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Moonlit-Raven-1120649731');//TODO:Update
                    break;
                case 'Wisteria Link Instagram':
                    window.open('https://www.instagram.com/p/DCNMOvfPRYY/?img_index=1');//TODO:Update
                    break;
                case 'Wisteria Link Youtube':
                    window.open('https://youtube.com/shorts/PnS7HQtPH7k');
                    break;
                case 'Wisteria Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Wisteria-Glory-Last-Boss-Concept-1120667912');//TODO:Update
                    break;
                case 'ShunnedHouse Link Instagram':
                    window.open('https://www.instagram.com/p/CrLkz_wrIMx/');//TODO:Update
                    break;
                case 'ShunnedHouse Link Youtube':
                    window.open('https://youtube.com/shorts/ydPN6Kn4KXg');
                    break;
                case 'ShunnedHouse Link DArt' :
                    window.open('https://www.deviantart.com/rinsdoll/art/Oddities-Abound-Travel-Poster-1120621366');//TODO:Update
                    break;
            }

        }
    }
}

export function animateAbout(intersections, aboutPanels) {
    
    if (intersections.length > 0){
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if (objectName.includes('About')) {
            if (objectName.includes('Cake')) {
                for ( let i = 5; i < 14; i++) {
                    if (!aboutOut){
                        gsap.to(aboutPanels[i].position, {
                            x: 2.4,
                            y: 0.8,
                            z: 0.35,
                            duration: 1.5,
                        });
                    }
                    else {
                        gsap.to(aboutPanels[i].position, {
                            x: 0,
                            y: 0,
                            z: 0,
                            duration: 1.5,
                        });
                    }
                    
                }
                if (!aboutOut) {
                    aboutOut = true;
                }
                else {
                    aboutOut = false;
                } 

            }
            else {
                switch (objectName) {
                    case 'About Profile' :
                        if (!aboutOut){
                            gsap.to(aboutPanels[0].position, {
                                x: 2,
                                y: -0.5,
                                z: -0.2,
                                duration: 1,
                            });
                            aboutOut = true;
                        }
                        else {
                            gsap.to(aboutPanels[0].position, {
                                x: 0,
                                y: 0,
                                z: 0,
                                duration: 1,
                            });
                            aboutOut = false;
                        }
                        break;
                    case 'About What I Do' :
                        if (!aboutOut){
                            gsap.to(aboutPanels[1].position, {
                                x: 1.4,
                                y: -0.8,
                                z: 1.3,
                                duration: 1,
                            });
                            aboutOut = true;
                        }
                        else {
                            gsap.to(aboutPanels[1].position, {
                                x: 0,
                                y: 0,
                                z: 0,
                                duration: 1,
                            });
                            aboutOut = false;
                        }
                        break;
                    case 'About Diploma' :
                        if (!aboutOut){
                            gsap.to(aboutPanels[2].position, {
                                x: 0.5,
                                y: -1,
                                z: 2.5,
                                duration: 1,
                            });
                            aboutOut = true;
                        }
                        else {
                            gsap.to(aboutPanels[2].position, {
                                x: 0,
                                y: 0,
                                z: 0,
                                duration: 1,
                            });
                            aboutOut = false;
                        }
                        break;
                    case 'About Programs' :
                        if (!aboutOut){
                            gsap.to(aboutPanels[4].position, {
                                x: 0.1,
                                y: 0.55,
                                z: 2.5,
                                duration: 1,
                            });
                            aboutOut = true;
                        }
                        else {
                            gsap.to(aboutPanels[4].position, {
                                x: 0,
                                y: 0,
                                z: 0,
                                duration: 1,
                            });
                            aboutOut = false;
                        }
                        break;
                    case 'About LinkB Artstation' :
                        window.open('https://www.artstation.com/rinsdoll', '_blank');
                        break;
                    case 'About LinkB Youtube' :
                        window.open('https://www.youtube.com/@rinsdoll', '_blank');
                        break;
                    case 'About LinkB Itch.io' :
                        window.open('https://rinsdoll.itch.io/', '_blank');
                        break;
                    case 'About LinkB Instagram' :
                        window.open('https://www.instagram.com/rinsdoll/', '_blank');
                        break;
                    case 'About LinkB DArt' :
                        window.open('https://www.deviantart.com/rinsdoll', '_blank');
                        break;
                    case 'About LinkB LinkedIn' :
                        window.open('https://www.linkedin.com/in/rinsdoll/', '_blank');
                        break;
                    case 'About LinkB Email' :
                        window.open('mailto:rinsdoll@gmail.com')
                        break;
                    case 'About Resume Button' :
                        window.open('https://drive.google.com/file/d/1KqB32ZnnK3sfqme2qL85PIrzAN-fMmn8/view?usp=sharing');
                        break;
                    default :
                        break;
                    
                }

            }
            
        }
    }
}

export function animateGames(intersections, games, infoCards, linkButtons) {
    
    if (intersections.length > 0){
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if (objectName.includes('Game') && !atCenter) {
            switch (objectName) {
                case 'Game Case Alone' :
                    if (!gameOut){
                        tl.to(games[0].position, {
                            x: -0.17,
                            y: 2.2,
                            z: -4.8,
                            duration: 1,
                        })
                        .to(infoCards[13], {
                            onUpdate: function () {
                                infoCards[13].position.y = 2;
                                infoCards[13].visible = true;
                                linkButtons[27].position.y = 1.5;
                                linkButtons[27].visible = true;
                                linkButtons[34].position.y = 1.2;
                                linkButtons[34].visible = true;
                            }
                        })
                        gameOut = true;
                        linkButtons[45].position.y = 0.1;
                    }
                    else {
                        gsap.to(games[0].position, {
                            x: -0.15,
                            y: 2.08,
                            z: -8.5,
                            duration: 1,
                        });
                        games[0].rotation.y = Math.PI/-4.5;
                        gameOut = false;
                        infoCards[13].position.y = -2;
                        infoCards[13].visible = false;
                        linkButtons[27].position.y = -1.4;
                        linkButtons[27].visible = false;
                        linkButtons[34].position.y = -1.2;
                        linkButtons[34].visible = false;
                        infoCards[18].position.y = -2;
                        infoCards[18].visible = false;
                        linkButtons[38].position.y = -1.2;
                        linkButtons[38].visible = false;

                        linkButtons[45].position.y = -5;
                    }
                    break;
                case 'Game Case Cauldron' :
                    if (!gameOut){
                        tl.to(games[1].position, {
                            x: -0.17,
                            y: 2.2,
                            z: -4.8,
                            duration: 1,
                        })
                        .to(infoCards[14], {
                            onUpdate: function () {
                                infoCards[14].position.y = 2;
                                infoCards[14].visible = true;
                                linkButtons[28].position.y = 1.5;
                                linkButtons[28].visible = true;
                                linkButtons[35].position.y = 1.2;
                                linkButtons[35].visible = true;
                            }
                        })
                        gameOut = true;
                        linkButtons[45].position.y = 0.1;
                    }
                    else {
                        gsap.to(games[1].position, {
                            x: 0.7,
                            y: 2.08,
                            z: -7.8,
                            duration: 1,
                        });
                        games[1].rotation.y = Math.PI/-4.5;
                        gameOut = false;
                        infoCards[14].position.y = -2;
                        infoCards[14].visible = false;
                        linkButtons[28].position.y = -1.4;
                        linkButtons[28].visible = false;
                        linkButtons[35].position.y = -1.2;
                        linkButtons[35].visible = false;
                        infoCards[19].position.y = -2;
                        infoCards[19].visible = false;
                        linkButtons[39].position.y = -1.2;
                        linkButtons[39].visible = false;
                        linkButtons[45].position.y = -5;
                    }
                    break;
                case 'Game Case Party' :
                    if (!gameOut){
                        tl.to(games[2].position, {
                            x: -0.17,
                            y: 2.2,
                            z: -4.8,
                            duration: 1,
                        })
                        .to(infoCards[15], {
                            onUpdate: function () {
                                infoCards[15].position.y = 2;
                                infoCards[15].visible = true;
                                linkButtons[29].position.y = 1.5;
                                linkButtons[29].visible = true;
                                linkButtons[36].position.y = 1.2;
                                linkButtons[36].visible = true;
                            }
                        })
                        gameOut = true;
                        linkButtons[45].position.y = 0.1;
                    }
                    else {
                        gsap.to(games[2].position, {
                            x: 1.5,
                            y: 2.08,
                            z: -7.2,
                            duration: 1,
                        });
                        gameOut = false;
                        games[2].rotation.y = Math.PI/-4.5;
                        infoCards[15].position.y = -2;
                        infoCards[15].visible = false;
                        linkButtons[29].position.y = -1.4;
                        linkButtons[29].visible = false;
                        linkButtons[36].position.y = -1.2;
                        linkButtons[36].visible = false;
                        infoCards[20].position.y = -2;
                        infoCards[20].visible = false;
                        linkButtons[40].position.y = -1.2;
                        linkButtons[40].visible = false;
                        linkButtons[45].position.y = -5;
                    }
                    break;
                case 'Game Case Snail' :
                    if (!gameOut){
                        tl.to(games[3].position, {
                            x: -0.17,
                            y: 2.2,
                            z: -4.8,
                            duration: 1,
                        })
                        .to(infoCards[16], {
                            onUpdate: function () {
                                infoCards[16].position.y = 2;
                                infoCards[16].visible = true;
                                linkButtons[30].position.y = 1.5;
                                linkButtons[30].visible = true;
                                linkButtons[37].position.y = 1.2;
                                linkButtons[37].visible = true;
                            }
                        })
                        gameOut = true;
                        linkButtons[45].position.y = 0.1;
                    }
                    else {
                        gsap.to(games[3].position, {
                            x: -0.15,
                            y: 1.05,
                            z: -8.5,
                            duration: 1,
                        });
                        games[3].rotation.y = Math.PI/-4.5;
                        gameOut = false;
                        infoCards[16].position.y = -2;
                        infoCards[16].visible = false;
                        linkButtons[30].position.y = -1.4;
                        linkButtons[30].visible = false;
                        linkButtons[37].position.y = -1.2;
                        linkButtons[37].visible = false;
                        infoCards[21].position.y = -2;
                        infoCards[21].visible = false;
                        linkButtons[41].position.y = -1.2;
                        linkButtons[41].visible = false;
                        linkButtons[45].position.y = -5;
                    }
                    break;
                case 'Game Case Icarus':
                    if (!gameOut){
                        tl.to(games[4].position, {
                            x: -0.17,
                            y: 2.2,
                            z: -4.8,
                            duration: 1,
                        })
                        .to(infoCards[16], {
                            onUpdate: function () {
                                infoCards[22].position.y = 2;
                                infoCards[22].visible = true;
                                linkButtons[44].position.y = 1.5;
                                linkButtons[44].visible = true;
                                linkButtons[42].position.y = 1.2;
                                linkButtons[42].visible = true;
                            }
                        })
                        gameOut = true;
                        linkButtons[45].position.y = 0.1;
                    }
                    else {
                        gsap.to(games[4].position, {
                            x: 1.5,
                            y: 1.05,
                            z: -7.2,
                            duration: 1,
                        });
                        games[3].rotation.y = Math.PI/-4.5;
                        gameOut = false;
                        infoCards[22].position.y = -2;
                        infoCards[22].visible = false;
                        linkButtons[44].position.y = -1.4;
                        linkButtons[44].visible = false;
                        linkButtons[42].position.y = -1.2;
                        linkButtons[42].visible = false;
                        infoCards[23].position.y = -2;
                        infoCards[23].visible = false;
                        linkButtons[43].position.y = -1.2;
                        linkButtons[43].visible = false;
                        linkButtons[45].position.y = -5;
                    }
                    break;
            }

        }
        else if (objectName.includes('Link')) {
            switch(objectName) {
                case "Alone Link Itch" :
                    window.open('https://rinsdoll.itch.io/alone-on-the-farm');
                    break;
                case "Cauldron Link Itch" :
                    window.open('https://failgod.itch.io/cauldron-chaos');
                    break;
                case "Party Link Itch" :
                    window.open('https://rinsdoll.itch.io/the-party');
                    break;
                case "Snail Link Itch" :
                    window.open('https://rinsdoll.itch.io/the-snail');
                    break;
                case "Icarus Link Itch" :
                    window.open('https://firstcrow.itch.io/icarus');
                    break;
            }
        }
        else if (objectName.includes('Show')) {
            switch(objectName) {
                case "Alone Show More" :
                    gsap.to(games[0].rotation, {
                        y: Math.PI/1.25,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[13].position.y = -2;
                            infoCards[13].visible = false;
                            infoCards[18].position.y = 2;
                            infoCards[18].visible = true;
                            linkButtons[34].position.y = -1.2;
                            linkButtons[34].visible = false;
                            linkButtons[38].position.y = 1.2;
                            linkButtons[38].visible = true;
                        }
                    })
                    break;
                case "Alone Show Cover" :
                    gsap.to(games[0].rotation, {
                        y: Math.PI/-4.5,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[13].position.y = 2;
                            infoCards[13].visible = true;
                            infoCards[18].position.y = -2;
                            infoCards[18].visible = false;
                            linkButtons[34].position.y = 1.2;
                            linkButtons[34].visible = true;
                            linkButtons[38].position.y = -1.2;
                            linkButtons[38].visible = false;
                        }
                    })
                    break;
                case "Cauldron Show More" :
                    gsap.to(games[1].rotation, {
                        y: Math.PI/1.25,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[14].position.y = -2;
                            infoCards[14].visible = false;
                            infoCards[19].position.y = 2;
                            infoCards[19].visible = true;
                            linkButtons[35].position.y = -1.2;
                            linkButtons[35].visible = false;
                            linkButtons[39].position.y = 1.2;
                            linkButtons[39].visible = true;
                        }
                    })
                    break;
                case "Cauldron Show Cover" :
                    gsap.to(games[1].rotation, {
                        y: Math.PI/-4.5,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[14].position.y = 2;
                            infoCards[14].visible = true;
                            infoCards[19].position.y = -2;
                            infoCards[19].visible = false;
                            linkButtons[35].position.y = 1.2;
                            linkButtons[35].visible = true;
                            linkButtons[39].position.y = -1.2;
                            linkButtons[39].visible = false;
                        }
                    })
                    break;
                case "Party Show More" :
                    gsap.to(games[2].rotation, {
                        y: Math.PI/1.25,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[15].position.y = -2;
                            infoCards[15].visible = false;
                            infoCards[20].position.y = 2;
                            infoCards[20].visible = true;
                            linkButtons[36].position.y = -1.2;
                            linkButtons[36].visible = false;
                            linkButtons[40].position.y = 1.2;
                            linkButtons[40].visible = true;
                        }
                    })
                    break;
                case "Party Show Cover" :
                    gsap.to(games[2].rotation, {
                        y: Math.PI/-4.5,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[15].position.y = 2;
                            infoCards[15].visible = true;
                            infoCards[20].position.y = -2;
                            infoCards[20].visible = false;
                            linkButtons[36].position.y = 1.2;
                            linkButtons[36].visible = true;
                            linkButtons[40].position.y = -1.2;
                            linkButtons[40].visible = false;
                        }
                    })
                    break;
                case "Snail Show More" :
                    gsap.to(games[3].rotation, {
                        y: Math.PI/1.25,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[16].position.y = -2;
                            infoCards[16].visible = false;
                            infoCards[21].position.y = 2;
                            infoCards[21].visible = true;
                            linkButtons[37].position.y = -1.2;
                            linkButtons[37].visible = false;
                            linkButtons[41].position.y = 1.2;
                            linkButtons[41].visible = true;
                        }
                    })
                    break;
                case "Snail Show Cover" :
                    gsap.to(games[3].rotation, {
                        y: Math.PI/-4.5,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[16].position.y = 2;
                            infoCards[16].visible = true;
                            infoCards[21].position.y = -2;
                            infoCards[21].visible = false;
                            linkButtons[37].position.y = 1.2;
                            linkButtons[37].visible = true;
                            linkButtons[41].position.y = -1.2;
                            linkButtons[41].visible = false;
                        }
                    })
                    break;
                case "Icarus Show More" :
                    gsap.to(games[4].rotation, {
                        y: Math.PI/1.25,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[22].position.y = -2;
                            infoCards[22].visible = false;
                            infoCards[23].position.y = 2;
                            infoCards[23].visible = true;
                            linkButtons[42].position.y = -1.2;
                            linkButtons[42].visible = false;
                            linkButtons[43].position.y = 1.2;
                            linkButtons[43].visible = true;
                        }
                    })
                    break;
                case "Icarus Show Cover" :
                    gsap.to(games[4].rotation, {
                        y: Math.PI/-4.5,
                        duration: 1,
                        onUpdate: function () {
                            infoCards[22].position.y = 2;
                            infoCards[22].visible = true;
                            infoCards[23].position.y = -2;
                            infoCards[23].visible = false;
                            linkButtons[42].position.y = 1.2;
                            linkButtons[42].visible = true;
                            linkButtons[43].position.y = -1.2;
                            linkButtons[43].visible = false;
                        }
                    })
                    break;
            }
        }
            
    }
}


export function animateInProg(intersections, inProgPanels, linkButtons) {
    
    if (intersections.length > 0){
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if (objectName.includes('InProg') && !atCenter) {
            switch (objectName) {
                case 'InProg Screen 1 Work' :
                    if (!inProgOut){
                        gsap.to(inProgPanels[1].position, {
                            x: 4.3,
                            y: 4,
                            z: -1,
                            duration: 1,
                        });
                        gsap.to(inProgPanels[1].rotation, {
                            x: 0,
                            y: Math.PI/-2.1,
                            z: 0,
                            duration: 1,
                        });
                        linkButtons[32].position.y = 4;
                        inProgOut = true;
                    }
                    else {
                        gsap.to(inProgPanels[1].position, {
                            x: 7.11,
                            y: 3.81,
                            z: -2.8,
                            duration: 1,
                        });
                        gsap.to(inProgPanels[1].rotation, {
                            x: 0,
                            y: Math.PI/-4.5,
                            z: 0,
                            duration: 1,
                        });
                        linkButtons[32].position.y = -4;
                        inProgOut = false;
                    }
                    break;
                case 'InProg Screen 2 Work' :
                    if (!inProgOut){
                        gsap.to(inProgPanels[3].position, {
                            x: 4.3,
                            y: 4,
                            z: -1,
                            duration: 1,
                        });
                        gsap.to(inProgPanels[3].rotation, {
                            x: 0,
                            y: 0.09,
                            z: 0,
                            duration: 1,
                        });
                        linkButtons[32].position.y = 4;
                        inProgOut = true;
                    }
                    else {
                        gsap.to(inProgPanels[3].position, {
                            x: 7.11,
                            y: 3.79,
                            z: 0.67,
                            duration: 1,
                        });
                        gsap.to(inProgPanels[3].rotation, {
                            x: 0,
                            y: Math.PI/-4.5,
                            z: 0,
                            duration: 1,
                        });
                        linkButtons[32].position.y = -4;
                        inProgOut = false;
                    }
                    break;
                case 'InProg Screen 3 Work' :
                    if (!inProgOut){
                        gsap.to(inProgPanels[5].position, {
                            x: 4,
                            y: 4,
                            z: -1,
                            duration: 1,
                        });
                        linkButtons[32].position.y = 4;
                        inProgOut = true;
                    }
                    else {
                        gsap.to(inProgPanels[5].position, {
                            x: 8.15,
                            y: 3.5,
                            z: -1.2,
                            duration: 1,
                        });
                        linkButtons[32].position.y = -4;
                        inProgOut = false;
                    }
                    break;
            
            }

        }
            
    }
}

export function closeIntroduction(intersections, infoCards, linkButtons, introButton) {
    if (intersections.length > 0){
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if (objectName.includes("Back")) {
            infoCards[17].visible = false;
            infoCards[17].position.y = -5;
            linkButtons[33].position.y = -5;
            introButton.position.y = -5;
            introButton.visible = false;

        }
    }
}


